export const ALL_IMAGE_REQUEST = "ALL_IMAGE_REQUEST";
export const ALL_IMAGE_SUCCESS = "ALL_IMAGE_SUCCESS";
export const ALL_IMAGE_FAIL = "ALL_IMAGE_FAIL";

export const UPLOAD_IMAGE_REQUEST = "UPLOAD_IMAGE_REQUEST";
export const UPLOAD_IMAGE_SUCCESS = "UPLOAD_IMAGE_SUCCESS";
export const UPLOAD_IMAGE_FAIL = "UPLOAD_IMAGE_FAIL";

export const CLEAR_ERRORS = "CLEAR_ERRORS";